// Comprehensive dataset of all 36 States & Union Territories and 150+ Sacred Cities & Cultural Towns of India

export const stateImageMap = {
  "uttarakhand": "/assets/banner/vr-darshan/temples/kedarnath.webp",
  "uttar pradesh": "/assets/trending/kashi-vishwanath.webp",
  "gujarat": "/assets/trending/dwarkadhish.webp",
  "rajasthan": "/assets/trending/bhadrakali-temple.webp",
  "madhya pradesh": "/assets/trending/mahakaleshwar.webp",
  "maharashtra": "/assets/trending/trimbakeshwar.webp",
  "tamil nadu": "/assets/trending/rameshwaram.webp",
  "karnataka": "/assets/home/what-to-do/temple-5.webp",
  "kerala": "/assets/home/what-to-do/temple-3.webp",
  "andhra pradesh": "/assets/trending/mallikarjuna.webp",
  "telangana": "/assets/trending/mallikarjuna.webp",
  "odisha": "/assets/trending/jaganath-puri.webp",
  "west bengal": "/assets/trending/kalighat-kali.webp",
  "bihar": "/assets/trending/baidyanath.webp",
  "jharkhand": "/assets/trending/baidyanath.webp",
  "assam": "/assets/trending/kamakhya.webp",
  "punjab": "/assets/home/what-to-do/temple-4.webp",
  "haryana": "/assets/home/what-to-do/temple-6.webp",
  "himachal pradesh": "/assets/trending/jwalaji-temple.webp",
  "jammu & kashmir": "/assets/trending/vaishno-devi.webp",
  "jammu and kashmir": "/assets/trending/vaishno-devi.webp",
  "ladakh": "/assets/banner/vr-darshan/temples/kedarnath.webp",
  "goa": "/assets/home/what-to-do/temple-7.webp",
  "chhattisgarh": "/assets/trending/mahakaleshwar.webp",
  "delhi": "/assets/trending/ayodhya-mandir.webp",
  "sikkim": "/assets/trending/kamakhya.webp",
  "tripura": "/assets/trending/kamakhya.webp",
  "manipur": "/assets/trending/kamakhya.webp",
  "meghalaya": "/assets/trending/kamakhya.webp",
  "mizoram": "/assets/trending/kamakhya.webp",
  "nagaland": "/assets/trending/kamakhya.webp",
  "arunachal pradesh": "/assets/trending/kamakhya.webp",
  "puducherry": "/assets/trending/rameshwaram.webp",
  "chandigarh": "/assets/home/what-to-do/temple-2.webp",
  "andaman and nicobar islands": "/assets/trending/rameshwaram.webp",
  "dadra and nagar haveli and daman and diu": "/assets/trending/somnath.webp",
  "lakshadweep": "/assets/home/what-to-do/temple-3.webp"
};

export const getStateImage = (stateName) => {
  const key = (stateName || "").toLowerCase().trim();
  return stateImageMap[key] || "/assets/trending/kedarnath.webp";
};

// Active states that currently have temples in the platform database
export const ACTIVE_STATE_NAMES = new Set([
  "uttar pradesh",
  "uttarakhand",
  "uttrakhand",
  "gujarat",
  "maharashtra",
  "rajasthan",
  "madhya pradesh",
  "tamil nadu",
  "karnataka",
  "kerala",
  "andhra pradesh",
  "odisha",
  "jharkhand",
  "assam",
  "himachal pradesh",
  "jammu and kashmir",
  "jammu & kashmir",
  "delhi"
]);

// Active cities that currently have temples in the platform database
export const ACTIVE_CITY_KEYS = new Set([
  "varanasi",
  "ayodhya",
  "mathura",
  "vrindavan",
  "mirzapur",
  "kedarnath",
  "badrinath",
  "haridwar",
  "dwarka",
  "somnath",
  "ambaji",
  "pavagadh",
  "shirdi",
  "mumbai",
  "pune",
  "nashik",
  "trimbak",
  "rameswaram",
  "rameshwaram",
  "madurai",
  "tiruvannamalai",
  "palani",
  "tirupati",
  "srisailam",
  "vijayawada",
  "udupi",
  "kollur",
  "dharmasthala",
  "subrahmanya",
  "sabarimala",
  "guruvayur",
  "thiruvananthapuram",
  "thrissur",
  "ujjain",
  "omkareshwar",
  "khatu",
  "salasar",
  "nathdwara",
  "jaipur",
  "puri",
  "deoghar",
  "guwahati",
  "kangra",
  "jawalamukhi",
  "chintpurni",
  "bilaspur",
  "katra",
  "jammu",
  "anantnag",
  "new delhi",
  "delhi"
]);

export const doesStateHaveTemples = (stateName) => {
  if (!stateName) return false;
  const s = stateName.toLowerCase().replace(/&/g, "and").trim();
  for (const active of ACTIVE_STATE_NAMES) {
    const act = active.replace(/&/g, "and");
    if (s === act || s.includes(act) || act.includes(s)) return true;
  }
  return false;
};

export const doesCityHaveTemples = (cityName, query) => {
  const q = (query || "").toLowerCase().trim();
  const c = (cityName || "").toLowerCase().trim();
  const firstWord = c.split(/[\s(/,]+/)[0].toLowerCase();

  for (const active of ACTIVE_CITY_KEYS) {
    if (q === active || q.includes(active) || active.includes(q)) return true;
    if (c === active || c.includes(active) || active.includes(c)) return true;
    if (firstWord.length > 2 && (firstWord === active || firstWord.includes(active) || active.includes(firstWord))) return true;
  }
  return false;
};

// All 36 States & Union Territories of India
export const allStatesData = [
  {
    "type": "state",
    "id": "up",
    "name": "Uttar Pradesh",
    "location": "State • India",
    "image": "/assets/trending/kashi-vishwanath.webp",
    "route": "/listing?search=Uttar%20Pradesh",
    "keywords": [
      "uttar pradesh",
      "up",
      "varanasi",
      "kashi",
      "ayodhya",
      "mathura",
      "prayagraj",
      "lucknow",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "uk",
    "name": "Uttarakhand",
    "location": "State • India",
    "image": "/assets/banner/vr-darshan/temples/kedarnath.webp",
    "route": "/listing?search=Uttarakhand",
    "keywords": [
      "uttarakhand",
      "uttrakhand",
      "devbhoomi",
      "kedarnath",
      "badrinath",
      "haridwar",
      "rishikesh",
      "char dham",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "gj",
    "name": "Gujarat",
    "location": "State • India",
    "image": "/assets/trending/dwarkadhish.webp",
    "route": "/listing?search=Gujarat",
    "keywords": [
      "gujarat",
      "dwarka",
      "somnath",
      "ambaji",
      "pavagadh",
      "ahmedabad",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "mh",
    "name": "Maharashtra",
    "location": "State • India",
    "image": "/assets/trending/trimbakeshwar.webp",
    "route": "/listing?search=Maharashtra",
    "keywords": [
      "maharashtra",
      "shirdi",
      "mumbai",
      "pune",
      "nashik",
      "trimbakeshwar",
      "kolhapur",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "rj",
    "name": "Rajasthan",
    "location": "State • India",
    "image": "/assets/trending/bhadrakali-temple.webp",
    "route": "/listing?search=Rajasthan",
    "keywords": [
      "rajasthan",
      "jaipur",
      "khatu shyam",
      "salasar",
      "pushkar",
      "nathdwara",
      "udaipur",
      "jodhpur",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "mp",
    "name": "Madhya Pradesh",
    "location": "State • India",
    "image": "/assets/trending/mahakaleshwar.webp",
    "route": "/listing?search=Madhya%20Pradesh",
    "keywords": [
      "madhya pradesh",
      "mp",
      "ujjain",
      "omkareshwar",
      "khajuraho",
      "indore",
      "bhopal",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "tn",
    "name": "Tamil Nadu",
    "location": "State • India",
    "image": "/assets/trending/rameshwaram.webp",
    "route": "/listing?search=Tamil%20Nadu",
    "keywords": [
      "tamil nadu",
      "rameswaram",
      "madurai",
      "tiruvannamalai",
      "thanjavur",
      "chennai",
      "kanchipuram",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "ka",
    "name": "Karnataka",
    "location": "State • India",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "route": "/listing?search=Karnataka",
    "keywords": [
      "karnataka",
      "udupi",
      "kollur",
      "dharmasthala",
      "bengaluru",
      "mysore",
      "hampi",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "kl",
    "name": "Kerala",
    "location": "State • India",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "route": "/listing?search=Kerala",
    "keywords": [
      "kerala",
      "sabarimala",
      "guruvayur",
      "padmanabhaswamy",
      "thiruvananthapuram",
      "kochi",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "ap",
    "name": "Andhra Pradesh",
    "location": "State • India",
    "image": "/assets/trending/mallikarjuna.webp",
    "route": "/listing?search=Andhra%20Pradesh",
    "keywords": [
      "andhra pradesh",
      "tirupati",
      "tirumala",
      "srisailam",
      "vijayawada",
      "visakhapatnam",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "tg",
    "name": "Telangana",
    "location": "State • India",
    "image": "/assets/trending/mallikarjuna.webp",
    "route": "/coming-soon",
    "keywords": [
      "telangana",
      "hyderabad",
      "yadagirigutta",
      "warangal",
      "ramappa",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "or",
    "name": "Odisha",
    "location": "State • India",
    "image": "/assets/trending/jaganath-puri.webp",
    "route": "/listing?search=Odisha",
    "keywords": [
      "odisha",
      "orissa",
      "puri",
      "bhubaneswar",
      "konark",
      "jagannath",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "wb",
    "name": "West Bengal",
    "location": "State • India",
    "image": "/assets/trending/kalighat-kali.webp",
    "route": "/coming-soon",
    "keywords": [
      "west bengal",
      "bengal",
      "kolkata",
      "kalighat",
      "dakshineswar",
      "mayapur",
      "tarapith",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "br",
    "name": "Bihar",
    "location": "State • India",
    "image": "/assets/trending/baidyanath.webp",
    "route": "/coming-soon",
    "keywords": [
      "bihar",
      "patna",
      "gaya",
      "bodh gaya",
      "rajgir",
      "nalanda",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "jh",
    "name": "Jharkhand",
    "location": "State • India",
    "image": "/assets/trending/baidyanath.webp",
    "route": "/listing?search=Jharkhand",
    "keywords": [
      "jharkhand",
      "deoghar",
      "baidyanath",
      "ranchi",
      "shikharji",
      "parasmath",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "as",
    "name": "Assam",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/listing?search=Assam",
    "keywords": [
      "assam",
      "guwahati",
      "kamakhya",
      "tezpur",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "pb",
    "name": "Punjab",
    "location": "State • India",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "route": "/coming-soon",
    "keywords": [
      "punjab",
      "amritsar",
      "golden temple",
      "anandpur sahib",
      "patiala",
      "jalandhar",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "hr",
    "name": "Haryana",
    "location": "State • India",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "route": "/coming-soon",
    "keywords": [
      "haryana",
      "kurukshetra",
      "panchkula",
      "gurugram",
      "faridabad",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "hp",
    "name": "Himachal Pradesh",
    "location": "State • India",
    "image": "/assets/trending/jwalaji-temple.webp",
    "route": "/listing?search=Himachal%20Pradesh",
    "keywords": [
      "himachal pradesh",
      "himachal",
      "kangra",
      "jwala ji",
      "chintpurni",
      "shimla",
      "kullu",
      "manali",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "jk",
    "name": "Jammu and Kashmir",
    "location": "State • India",
    "image": "/assets/trending/vaishno-devi.webp",
    "route": "/listing?search=Jammu%20and%20Kashmir",
    "keywords": [
      "jammu & kashmir",
      "jammu and kashmir",
      "j&k",
      "katra",
      "vaishno devi",
      "amarnath",
      "srinagar",
      "state",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "la",
    "name": "Ladakh",
    "location": "Union Territory • India",
    "image": "/assets/banner/vr-darshan/temples/kedarnath.webp",
    "route": "/coming-soon",
    "keywords": [
      "ladakh",
      "leh",
      "kargil",
      "nubra",
      "himalayas",
      "union territory",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ct",
    "name": "Chhattisgarh",
    "location": "State • India",
    "image": "/assets/trending/mahakaleshwar.webp",
    "route": "/coming-soon",
    "keywords": [
      "chhattisgarh",
      "raipur",
      "bilaspur",
      "dantewada",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ga",
    "name": "Goa",
    "location": "State • India",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "route": "/coming-soon",
    "keywords": [
      "goa",
      "panaji",
      "ponda",
      "mangueshi",
      "shanta durga",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "dl",
    "name": "Delhi",
    "location": "National Capital Territory • India",
    "image": "/assets/trending/ayodhya-mandir.webp",
    "route": "/listing?search=Delhi",
    "keywords": [
      "delhi",
      "new delhi",
      "ncr",
      "akshardham",
      "kalkaji",
      "bangla sahib",
      "capital",
      "india"
    ],
    "hasTemples": true
  },
  {
    "type": "state",
    "id": "sk",
    "name": "Sikkim",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "sikkim",
      "gangtok",
      "namchi",
      "char dham sikkim",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "tr",
    "name": "Tripura",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "tripura",
      "agartala",
      "tripura sundari",
      "matabari",
      "shaktipeeth",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "mn",
    "name": "Manipur",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "manipur",
      "imphal",
      "govindaji",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ml",
    "name": "Meghalaya",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "meghalaya",
      "shillong",
      "nartiang",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "mz",
    "name": "Mizoram",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "mizoram",
      "aizawl",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "nl",
    "name": "Nagaland",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "nagaland",
      "kohima",
      "dimapur",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ar",
    "name": "Arunachal Pradesh",
    "location": "State • India",
    "image": "/assets/trending/kamakhya.webp",
    "route": "/coming-soon",
    "keywords": [
      "arunachal pradesh",
      "tawang",
      "itanagar",
      "parshuram kund",
      "state",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "py",
    "name": "Puducherry",
    "location": "Union Territory • India",
    "image": "/assets/trending/rameshwaram.webp",
    "route": "/coming-soon",
    "keywords": [
      "puducherry",
      "pondicherry",
      "auroville",
      "manakula vinayagar",
      "union territory",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ch",
    "name": "Chandigarh",
    "location": "Union Territory • India",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "route": "/coming-soon",
    "keywords": [
      "chandigarh",
      "chandi mandir",
      "union territory",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "an",
    "name": "Andaman and Nicobar Islands",
    "location": "Union Territory • India",
    "image": "/assets/trending/rameshwaram.webp",
    "route": "/coming-soon",
    "keywords": [
      "andaman",
      "nicobar",
      "port blair",
      "cellular jail",
      "murugan",
      "union territory",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "dn",
    "name": "Dadra and Nagar Haveli and Daman and Diu",
    "location": "Union Territory • India",
    "image": "/assets/trending/somnath.webp",
    "route": "/coming-soon",
    "keywords": [
      "daman",
      "diu",
      "silvassa",
      "dadra",
      "nagar haveli",
      "union territory",
      "india"
    ],
    "hasTemples": false
  },
  {
    "type": "state",
    "id": "ld",
    "name": "Lakshadweep",
    "location": "Union Territory • India",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "route": "/coming-soon",
    "keywords": [
      "lakshadweep",
      "kavaratti",
      "islands",
      "union territory",
      "india"
    ],
    "hasTemples": false
  }
];

// 168+ Comprehensive Sacred Cities, Temple Hubs & Cultural Centers
export const allCitiesData = [
  {
    "name": "Varanasi (Kashi / Banaras)",
    "state": "Uttar Pradesh",
    "query": "Varanasi",
    "image": "/assets/trending/kashi-vishwanath.webp",
    "keywords": [
      "kashi",
      "banaras",
      "varanasi",
      "ganga",
      "vishwanath",
      "ghat",
      "manikarnika",
      "sarnath",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Varanasi"
  },
  {
    "name": "Ayodhya",
    "state": "Uttar Pradesh",
    "query": "Ayodhya",
    "image": "/assets/trending/ayodhya-mandir.webp",
    "keywords": [
      "ayodhya",
      "ram",
      "janmabhoomi",
      "hanuman garhi",
      "sarayu",
      "kanak bhavan",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Ayodhya"
  },
  {
    "name": "Mathura",
    "state": "Uttar Pradesh",
    "query": "Mathura",
    "image": "/assets/temple-images/krishna-janmabhoomi-mathura/timing.jpg",
    "keywords": [
      "mathura",
      "krishna janmabhoomi",
      "dwarkadhish",
      "yamuna",
      "vishram ghat",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Mathura"
  },
  {
    "name": "Vrindavan",
    "state": "Uttar Pradesh",
    "query": "Vrindavan",
    "image": "/assets/temple-images/banke-bihari-temple-vrindavan/timing.jpg",
    "keywords": [
      "vrindavan",
      "banke bihari",
      "prem mandir",
      "iskcon",
      "radha vallabh",
      "nidhivan",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Vrindavan"
  },
  {
    "name": "Prayagraj (Allahabad)",
    "state": "Uttar Pradesh",
    "query": "Prayagraj",
    "image": "/assets/trending/varanasi.webp",
    "keywords": [
      "prayagraj",
      "allahabad",
      "sangam",
      "triveni",
      "kumbh mela",
      "alopi devi",
      "bade hanuman",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Chitrakoot",
    "state": "Uttar Pradesh",
    "query": "Chitrakoot",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "chitrakoot",
      "ramghat",
      "kamadgiri",
      "hanuman dhara",
      "gupt godavari",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Mirzapur (Vindhyachal)",
    "state": "Uttar Pradesh",
    "query": "Mirzapur",
    "image": "/assets/temple-images/vindhyavasini-devi-temple-mirzapur/timing.jpg",
    "keywords": [
      "mirzapur",
      "vindhyachal",
      "vindhyavasini",
      "ashtabhuja",
      "kali khoh",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Mirzapur"
  },
  {
    "name": "Naimisharanya",
    "state": "Uttar Pradesh",
    "query": "Naimisharanya",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "naimisharanya",
      "sitapur",
      "chakra tirth",
      "lalita devi",
      "vyas gaddi",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Barsana",
    "state": "Uttar Pradesh",
    "query": "Barsana",
    "image": "/assets/trending/krishna.webp",
    "keywords": [
      "barsana",
      "radha rani",
      "shriji mandir",
      "ladli ji",
      "lathmar holi",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Govardhan",
    "state": "Uttar Pradesh",
    "query": "Govardhan",
    "image": "/assets/trending/krishna.webp",
    "keywords": [
      "govardhan",
      "parikrama",
      "manasi ganga",
      "dan ghati",
      "radha kund",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gokul",
    "state": "Uttar Pradesh",
    "query": "Gokul",
    "image": "/assets/trending/krishna.webp",
    "keywords": [
      "gokul",
      "raman reti",
      "nandgaon",
      "chaurasi khamba",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gorakhpur",
    "state": "Uttar Pradesh",
    "query": "Gorakhpur",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "gorakhpur",
      "gorakhnath mandir",
      "guru gorakhnath",
      "gita press",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Lucknow",
    "state": "Uttar Pradesh",
    "query": "Lucknow",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "lucknow",
      "chandrika devi",
      "hanuman setu",
      "gomti",
      "capital",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Agra",
    "state": "Uttar Pradesh",
    "query": "Agra",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "agra",
      "bateshwar",
      "kailash mandir",
      "yamuna",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kanpur",
    "state": "Uttar Pradesh",
    "query": "Kanpur",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "kanpur",
      "bithoor",
      "j.k. temple",
      "iskcon kanpur",
      "ganga",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kushinagar",
    "state": "Uttar Pradesh",
    "query": "Kushinagar",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "kushinagar",
      "mahaparinirvana",
      "buddha",
      "ramabhar stupa",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Sarnath",
    "state": "Uttar Pradesh",
    "query": "Sarnath",
    "image": "/assets/ashok-stambh.png",
    "keywords": [
      "sarnath",
      "dhamek stupa",
      "deer park",
      "buddha",
      "ashoka pillar",
      "uttar pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kedarnath",
    "state": "Uttarakhand",
    "query": "Kedarnath",
    "image": "/assets/banner/vr-darshan/temples/kedarnath.webp",
    "keywords": [
      "kedarnath",
      "shiva",
      "jyotirlinga",
      "char dham",
      "rudraprayag",
      "mandakini",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Kedarnath"
  },
  {
    "name": "Badrinath",
    "state": "Uttarakhand",
    "query": "Badrinath",
    "image": "/assets/trending/badrinath.webp",
    "keywords": [
      "badrinath",
      "badri vishal",
      "vishnu",
      "char dham",
      "chamoli",
      "alaknanda",
      "tapt kund",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Badrinath"
  },
  {
    "name": "Haridwar",
    "state": "Uttarakhand",
    "query": "Haridwar",
    "image": "/assets/temple-images/har-ki-pauri-haridwar/timing.jpg",
    "keywords": [
      "haridwar",
      "har ki pauri",
      "ganga aarti",
      "mansa devi",
      "chandi devi",
      "kumbh mela",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Haridwar"
  },
  {
    "name": "Rishikesh",
    "state": "Uttarakhand",
    "query": "Rishikesh",
    "image": "/assets/trending/yamunotri.webp",
    "keywords": [
      "rishikesh",
      "triveni ghat",
      "ram jhula",
      "lakshman jhula",
      "ganga",
      "neelkanth mahadev",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gangotri",
    "state": "Uttarakhand",
    "query": "Gangotri",
    "image": "/assets/trending/gangotri.webp",
    "keywords": [
      "gangotri",
      "ganga",
      "bhagirathi",
      "char dham",
      "uttarkashi",
      "gaumukh",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Yamunotri",
    "state": "Uttarakhand",
    "query": "Yamunotri",
    "image": "/assets/trending/yamunotri.webp",
    "keywords": [
      "yamunotri",
      "yamuna",
      "char dham",
      "uttarkashi",
      "divya shila",
      "surya kund",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Dehradun",
    "state": "Uttarakhand",
    "query": "Dehradun",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "dehradun",
      "tapkeshwar mahadev",
      "prakasheshwar mahadev",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Nainital",
    "state": "Uttarakhand",
    "query": "Nainital",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "nainital",
      "naina devi",
      "shaktipeeth",
      "naini lake",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Almora (Jageshwar Dham)",
    "state": "Uttarakhand",
    "query": "Almora",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "almora",
      "jageshwar",
      "jageshwar dham",
      "kasar devi",
      "chitai golu devta",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Joshimath (Jyotirmath)",
    "state": "Uttarakhand",
    "query": "Joshimath",
    "image": "/assets/banner/vr-darshan/temples/kedarnath.webp",
    "keywords": [
      "joshimath",
      "jyotirmath",
      "shankaracharya math",
      "narasimha temple",
      "badrinath base",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Uttarkashi",
    "state": "Uttarakhand",
    "query": "Uttarkashi",
    "image": "/assets/trending/gangotri.webp",
    "keywords": [
      "uttarkashi",
      "kashi vishwanath uttarkashi",
      "shakti temple",
      "bhagirathi",
      "uttarakhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Dwarka",
    "state": "Gujarat",
    "query": "Dwarka",
    "image": "/assets/trending/dwarkadhish.webp",
    "keywords": [
      "dwarka",
      "dwarkadhish",
      "krishna",
      "char dham",
      "gomti ghat",
      "bet dwarka",
      "nageshwar",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Dwarka"
  },
  {
    "name": "Somnath (Veraval)",
    "state": "Gujarat",
    "query": "Somnath",
    "image": "/assets/trending/somnath.webp",
    "keywords": [
      "somnath",
      "veraval",
      "jyotirlinga",
      "first jyotirlinga",
      "prabhas patan",
      "bhalka tirth",
      "shiva",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Somnath"
  },
  {
    "name": "Ambaji",
    "state": "Gujarat",
    "query": "Ambaji",
    "image": "/assets/temple-images/ambaji-temple-gujarat/timing.jpg",
    "keywords": [
      "ambaji",
      "shaktipeeth",
      "gabbar hill",
      "arasur",
      "banaskantha",
      "am ba",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Ambaji"
  },
  {
    "name": "Pavagadh",
    "state": "Gujarat",
    "query": "Pavagadh",
    "image": "/assets/temple-images/pavagadh-kalika-mata-temple/timing.jpg",
    "keywords": [
      "pavagadh",
      "kalika mata",
      "mahakali",
      "champaner",
      "shaktipeeth",
      "ropeway",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Pavagadh"
  },
  {
    "name": "Ahmedabad",
    "state": "Gujarat",
    "query": "Ahmedabad",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "ahmedabad",
      "akshardham",
      "jagannath temple ahmedabad",
      "bhadra kali",
      "iskcon",
      "camp hanuman",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gandhinagar",
    "state": "Gujarat",
    "query": "Gandhinagar",
    "image": "/assets/temple-images/akshardham-temple-delhi/timing.jpg",
    "keywords": [
      "gandhinagar",
      "akshardham gujarat",
      "swaminarayan",
      "capital",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Dakor",
    "state": "Gujarat",
    "query": "Dakor",
    "image": "/assets/trending/krishna.webp",
    "keywords": [
      "dakor",
      "ranchhodraiji",
      "krishna",
      "kheda",
      "gomti lake",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Junagadh (Girnar)",
    "state": "Gujarat",
    "query": "Junagadh",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "junagadh",
      "girnar",
      "dattatreya",
      "ambaji girnar",
      "bhavnath mahadev",
      "jain tirth",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Palitana",
    "state": "Gujarat",
    "query": "Palitana",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "palitana",
      "shatrunjaya",
      "jain temples",
      "adinath",
      "bhavnagar",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Jamnagar",
    "state": "Gujarat",
    "query": "Jamnagar",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "jamnagar",
      "bala hanuman",
      "ramdhun",
      "lakhota lake",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Vadodara (Baroda)",
    "state": "Gujarat",
    "query": "Vadodara",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "vadodara",
      "baroda",
      "kayavarohan",
      "lakulisha",
      "kuber bhandari",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Surat",
    "state": "Gujarat",
    "query": "Surat",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "surat",
      "ambika niketan",
      "chintamani jain",
      "iskcon surat",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Modhera",
    "state": "Gujarat",
    "query": "Modhera",
    "image": "/assets/trending/bhadrakali-temple.webp",
    "keywords": [
      "modhera",
      "sun temple",
      "surya mandir",
      "kund",
      "mehsana",
      "gujarat"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Shirdi",
    "state": "Maharashtra",
    "query": "Shirdi",
    "image": "/assets/temple-images/shirdi-sai-baba-temple/timing.jpg",
    "keywords": [
      "shirdi",
      "sai baba",
      "samadhi mandir",
      "dwarkamai",
      "chavadi",
      "ahmednagar",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Shirdi"
  },
  {
    "name": "Mumbai",
    "state": "Maharashtra",
    "query": "Mumbai",
    "image": "/assets/temple-images/siddhivinayak-temple-mumbai/timing.jpg",
    "keywords": [
      "mumbai",
      "siddhivinayak",
      "mahalaxmi mumbai",
      "mumba devi",
      "babulnath",
      "iskcon juhu",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Mumbai"
  },
  {
    "name": "Pune",
    "state": "Maharashtra",
    "query": "Pune",
    "image": "/assets/temple-images/shreemant-dagdusheth-halwai-ganpati-pune/timing.jpg",
    "keywords": [
      "pune",
      "dagdusheth",
      "ganpati",
      "alandi",
      "dehu",
      "kasba ganpati",
      "parvati hill",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Pune"
  },
  {
    "name": "Nashik (Trimbak)",
    "state": "Maharashtra",
    "query": "Nashik",
    "image": "/assets/trending/trimbakeshwar.webp",
    "keywords": [
      "nashik",
      "trimbakeshwar",
      "jyotirlinga",
      "panchavati",
      "kalaram mandir",
      "kumbh mela",
      "godavari",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Nashik"
  },
  {
    "name": "Kolhapur",
    "state": "Maharashtra",
    "query": "Kolhapur",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "kolhapur",
      "mahalaxmi",
      "ambabai",
      "shaktipeeth",
      "panchganga",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Pandharpur",
    "state": "Maharashtra",
    "query": "Pandharpur",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "pandharpur",
      "vithoba",
      "vitthal rukmini",
      "chandrabhaga",
      "wari",
      "solapur",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Bhimashankar",
    "state": "Maharashtra",
    "query": "Bhimashankar",
    "image": "/assets/trending/bhimashankar.webp",
    "keywords": [
      "bhimashankar",
      "jyotirlinga",
      "shiva",
      "sahyadri",
      "bhima river",
      "pune",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Chhatrapati Sambhajinagar (Aurangabad / Grishneshwar)",
    "state": "Maharashtra",
    "query": "Grishneshwar",
    "image": "/assets/trending/grishneshwar.webp",
    "keywords": [
      "aurangabad",
      "sambhajinagar",
      "grishneshwar",
      "ghrushneshwar",
      "jyotirlinga",
      "ellora",
      "verul",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Tuljapur",
    "state": "Maharashtra",
    "query": "Tuljapur",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "tuljapur",
      "bhavani mata",
      "tulja bhavani",
      "chhatrapati shivaji",
      "osmanabad",
      "dharashiv",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Shegaon",
    "state": "Maharashtra",
    "query": "Shegaon",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "shegaon",
      "gajanan maharaj",
      "anand sagar",
      "buldhana",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Nanded",
    "state": "Maharashtra",
    "query": "Nanded",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "nanded",
      "hazur sahib",
      "takht sachkhand",
      "guru gobind singh",
      "godavari",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ganpatipule",
    "state": "Maharashtra",
    "query": "Ganpatipule",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "ganpatipule",
      "swayambhu ganpati",
      "konkan",
      "ratnagiri",
      "sea temple",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Nagpur",
    "state": "Maharashtra",
    "query": "Nagpur",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "nagpur",
      "tekdi ganesh",
      "dragon palace",
      "koradi mandir",
      "deekshabhoomi",
      "maharashtra"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Rameswaram",
    "state": "Tamil Nadu",
    "query": "Rameswaram",
    "image": "/assets/trending/rameshwaram.webp",
    "keywords": [
      "rameswaram",
      "rameshwaram",
      "ramanathaswamy",
      "jyotirlinga",
      "char dham",
      "agni theertham",
      "dhanushkodi",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Rameswaram"
  },
  {
    "name": "Madurai",
    "state": "Tamil Nadu",
    "query": "Madurai",
    "image": "/assets/temple-images/meenakshi-amman-temple-madurai/timing.jpg",
    "keywords": [
      "madurai",
      "meenakshi amman",
      "sundareswarar",
      "vaigai",
      "temple city",
      "thousand pillar",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Madurai"
  },
  {
    "name": "Tiruvannamalai",
    "state": "Tamil Nadu",
    "query": "Tiruvannamalai",
    "image": "/assets/temple-images/arunachaleswarar-temple-tiruvannamalai/timing.jpg",
    "keywords": [
      "tiruvannamalai",
      "arunachaleswarar",
      "arunachala",
      "girivalam",
      "pancha bhoota agni",
      "ramana maharshi",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Tiruvannamalai"
  },
  {
    "name": "Thanjavur (Tanjore)",
    "state": "Tamil Nadu",
    "query": "Thanjavur",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "thanjavur",
      "tanjore",
      "brihadeeswarar",
      "big temple",
      "chola",
      "unesco",
      "kaveri",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kanchipuram",
    "state": "Tamil Nadu",
    "query": "Kanchipuram",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "kanchipuram",
      "kamakshi amman",
      "ekambareswarar",
      "varadharaja perumal",
      "shaktipeeth",
      "mokshapuri",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Tiruchirappalli (Trichy / Srirangam)",
    "state": "Tamil Nadu",
    "query": "Srirangam",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "trichy",
      "tiruchirappalli",
      "srirangam",
      "ranganathaswamy",
      "rockfort ucchi pillayar",
      "samayapuram mariamman",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Palani",
    "state": "Tamil Nadu",
    "query": "Palani",
    "image": "/assets/temple-images/palani-murugan-temple-tamil-nadu/timing.jpg",
    "keywords": [
      "palani",
      "dhandayuthapani",
      "murugan",
      "arupradaiveedu",
      "dindigul",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Palani"
  },
  {
    "name": "Chidambaram",
    "state": "Tamil Nadu",
    "query": "Chidambaram",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "chidambaram",
      "thillai nataraja",
      "pancha bhoota akasha",
      "shiva dance",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Tiruchendur",
    "state": "Tamil Nadu",
    "query": "Tiruchendur",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "tiruchendur",
      "subramanya swamy",
      "murugan",
      "seashore temple",
      "soorasamharam",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kanyakumari",
    "state": "Tamil Nadu",
    "query": "Kanyakumari",
    "image": "/assets/trending/rameshwaram.webp",
    "keywords": [
      "kanyakumari",
      "bhagavathy amman",
      "vivekananda rock",
      "thiruvalluvar",
      "triveni sangam",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Chennai",
    "state": "Tamil Nadu",
    "query": "Chennai",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "chennai",
      "kapaleeshwarar",
      "mylapore",
      "parthasarathy",
      "triplicane",
      "vadapalani",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kumbakonam",
    "state": "Tamil Nadu",
    "query": "Kumbakonam",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "kumbakonam",
      "mahamaham",
      "adi kumbeswarar",
      "sarangapani",
      "navagraha temples",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Coimbatore",
    "state": "Tamil Nadu",
    "query": "Coimbatore",
    "image": "/assets/home/what-to-do/temple-8.webp",
    "keywords": [
      "coimbatore",
      "marudhamalai",
      "ishwara dhyanalinga",
      "adiyogi",
      "eachanari vinayagar",
      "tamil nadu"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Tirupati (Tirumala)",
    "state": "Andhra Pradesh",
    "query": "Tirupati",
    "image": "/assets/temple-images/tirupati-balaji-temple/timing.jpg",
    "keywords": [
      "tirupati",
      "tirumala",
      "balaji",
      "venkateswara",
      "govindaraja",
      "padmavathi",
      "alipiri",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Tirupati"
  },
  {
    "name": "Srisailam",
    "state": "Andhra Pradesh",
    "query": "Srisailam",
    "image": "/assets/trending/mallikarjuna.webp",
    "keywords": [
      "srisailam",
      "mallikarjuna",
      "bhramaramba",
      "jyotirlinga",
      "shaktipeeth",
      "krishna river",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Srisailam"
  },
  {
    "name": "Vijayawada",
    "state": "Andhra Pradesh",
    "query": "Vijayawada",
    "image": "/assets/temple-images/kanaka-durga-temple-vijayawada/timing.jpg",
    "keywords": [
      "vijayawada",
      "kanaka durga",
      "indrakeeladri",
      "krishna river",
      "prakasam barrage",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Vijayawada"
  },
  {
    "name": "Srikalahasti",
    "state": "Andhra Pradesh",
    "query": "Srikalahasti",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "srikalahasti",
      "kalahasteeswara",
      "rahu ketu puja",
      "pancha bhoota vayu",
      "swarnamukhi",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Visakhapatnam (Simhachalam)",
    "state": "Andhra Pradesh",
    "query": "Simhachalam",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "visakhapatnam",
      "vizag",
      "simhachalam",
      "varaha lakshmi narasimha",
      "chandana yatra",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Annavaram",
    "state": "Andhra Pradesh",
    "query": "Annavaram",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "annavaram",
      "satyanarayana swamy",
      "ratnagiri",
      "vratham",
      "east godavari",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kanipakam",
    "state": "Andhra Pradesh",
    "query": "Kanipakam",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "kanipakam",
      "varasiddhi vinayaka",
      "swayambhu ganesh",
      "chittoor",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ahobilam",
    "state": "Andhra Pradesh",
    "query": "Ahobilam",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "ahobilam",
      "nava narasimha",
      "nallamala",
      "kurnool",
      "prahlada",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Mantralayam",
    "state": "Andhra Pradesh",
    "query": "Mantralayam",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "mantralayam",
      "raghavendra swamy",
      "brindavanam",
      "tungabhadra",
      "kurnool",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Lepakshi",
    "state": "Andhra Pradesh",
    "query": "Lepakshi",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "lepakshi",
      "veerabhadra",
      "hanging pillar",
      "monolithic nandi",
      "anantapur",
      "andhra pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Udupi",
    "state": "Karnataka",
    "query": "Udupi",
    "image": "/assets/temple-images/udupi-sri-krishna-matha/timing.jpg",
    "keywords": [
      "udupi",
      "krishna matha",
      "madhvacharya",
      "kanakana kindi",
      "ashta mathas",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Udupi"
  },
  {
    "name": "Kollur",
    "state": "Karnataka",
    "query": "Kollur",
    "image": "/assets/temple-images/kollur-mookambika-temple-karnataka/timing.jpg",
    "keywords": [
      "kollur",
      "mookambika",
      "kodachadri",
      "shankaracharya",
      "shaktipeeth",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Kollur"
  },
  {
    "name": "Dharmasthala",
    "state": "Karnataka",
    "query": "Dharmasthala",
    "image": "/assets/temple-images/dharmasthala-manjunatha-temple/timing.jpg",
    "keywords": [
      "dharmasthala",
      "manjunatha",
      "shiva",
      "bahubali",
      "annadana",
      "netravati",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Dharmasthala"
  },
  {
    "name": "Kukke Subrahmanya",
    "state": "Karnataka",
    "query": "Subrahmanya",
    "image": "/assets/temple-images/kukke-subrahmanya-temple-karnataka/timing.jpg",
    "keywords": [
      "kukke",
      "subrahmanya",
      "sarpa dosha",
      "ashlesha bali",
      "kumaradhara",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Subrahmanya"
  },
  {
    "name": "Gokarna",
    "state": "Karnataka",
    "query": "Gokarna",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "gokarna",
      "mahabaleshwar",
      "atmalinga",
      "ravana",
      "om beach",
      "shiva",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Murudeshwar",
    "state": "Karnataka",
    "query": "Murudeshwar",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "murudeshwar",
      "shiva statue",
      "raja gopura",
      "arabian sea",
      "uttara kannada",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Hampi",
    "state": "Karnataka",
    "query": "Hampi",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "hampi",
      "virupaksha",
      "vijayanagara",
      "stone chariot",
      "vittala temple",
      "unesco",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Sringeri",
    "state": "Karnataka",
    "query": "Sringeri",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "sringeri",
      "sharada peetham",
      "shankaracharya",
      "vidyashankara",
      "tunga river",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Bengaluru (Bangalore)",
    "state": "Karnataka",
    "query": "Bengaluru",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "bengaluru",
      "bangalore",
      "iskcon bangalore",
      "bull temple",
      "dodda ganesha",
      "gavi gangadhareshwara",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Mysuru (Mysore)",
    "state": "Karnataka",
    "query": "Mysuru",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "mysuru",
      "mysore",
      "chamundeshwari",
      "chamundi hill",
      "nandi mysore",
      "dasara",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Horanadu",
    "state": "Karnataka",
    "query": "Horanadu",
    "image": "/assets/home/what-to-do/temple-8.webp",
    "keywords": [
      "horanadu",
      "annapoorneshwari",
      "chikkamagaluru",
      "bhadra river",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Badami",
    "state": "Karnataka",
    "query": "Badami",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "badami",
      "cave temples",
      "banashankari",
      "pattadakal",
      "aihole",
      "chalukya",
      "karnataka"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Sabarimala",
    "state": "Kerala",
    "query": "Sabarimala",
    "image": "/assets/temple-images/sabarimala-ayyappa-temple/timing.jpg",
    "keywords": [
      "sabarimala",
      "ayyappa",
      "makaravilakku",
      "18 steps",
      "pathanamthitta",
      "pamba",
      "kerala"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Sabarimala"
  },
  {
    "name": "Guruvayur",
    "state": "Kerala",
    "query": "Guruvayur",
    "image": "/assets/temple-images/guruvayur-temple/timing.jpg",
    "keywords": [
      "guruvayur",
      "guruvayurappan",
      "krishna",
      "thrissur",
      "aanakotta",
      "kerala"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Guruvayur"
  },
  {
    "name": "Thiruvananthapuram (Trivandrum)",
    "state": "Kerala",
    "query": "Padmanabhaswamy",
    "image": "/assets/temple-images/padmanabhaswamy-temple-kerala/timing.jpg",
    "keywords": [
      "thiruvananthapuram",
      "trivandrum",
      "padmanabhaswamy",
      "vishnu",
      "ananta sayana",
      "attukal",
      "kerala"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Padmanabhaswamy"
  },
  {
    "name": "Kochi (Cochin)",
    "state": "Kerala",
    "query": "Kochi",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "kochi",
      "cochin",
      "chottanikkara bhagavathy",
      "poornathrayeesa",
      "ernakulathappan",
      "kerala"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Thrissur",
    "state": "Kerala",
    "query": "Thrissur",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "thrissur",
      "vadakkunnathan",
      "shiva",
      "thrissur pooram",
      "paramekkavu",
      "thiruvambadi",
      "kerala"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Thrissur"
  },
  {
    "name": "Attukal",
    "state": "Kerala",
    "query": "Attukal",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "attukal",
      "attukal bhagavathy",
      "pongala",
      "women sabarimala",
      "trivandrum",
      "kerala"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Vaikom",
    "state": "Kerala",
    "query": "Vaikom",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "vaikom",
      "vaikathappan",
      "mahadeva",
      "shiva",
      "kottayam",
      "kerala"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ujjain",
    "state": "Madhya Pradesh",
    "query": "Ujjain",
    "image": "/assets/trending/mahakaleshwar.webp",
    "keywords": [
      "ujjain",
      "mahakaleshwar",
      "mahakal",
      "bhasma aarti",
      "jyotirlinga",
      "kal bhairav",
      "shipra",
      "kumbh mela",
      "harsiddhi",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Ujjain"
  },
  {
    "name": "Omkareshwar",
    "state": "Madhya Pradesh",
    "query": "Omkareshwar",
    "image": "/assets/trending/omkareshwar.webp",
    "keywords": [
      "omkareshwar",
      "mamleshwar",
      "jyotirlinga",
      "narmada",
      "island om",
      "khandwa",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Omkareshwar"
  },
  {
    "name": "Khajuraho",
    "state": "Madhya Pradesh",
    "query": "Khajuraho",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "khajuraho",
      "kandariya mahadeva",
      "unesco",
      "chandel",
      "chhatarpur",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Maihar",
    "state": "Madhya Pradesh",
    "query": "Maihar",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "maihar",
      "sharda devi",
      "maa sharda",
      "trikuta hill",
      "satna",
      "shaktipeeth",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Amarkantak",
    "state": "Madhya Pradesh",
    "query": "Amarkantak",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "amarkantak",
      "narmada udgam",
      "narmada temple",
      "maikal hills",
      "anuppur",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Orchha",
    "state": "Madhya Pradesh",
    "query": "Orchha",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "orchha",
      "ram raja mandir",
      "chaturbhuj temple",
      "betwa",
      "niwari",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Indore",
    "state": "Madhya Pradesh",
    "query": "Indore",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "indore",
      "khajrana ganesh",
      "annapurna mandir",
      "pitar parvat",
      "bada ganpati",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gwalior",
    "state": "Madhya Pradesh",
    "query": "Gwalior",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "gwalior",
      "surya mandir",
      "sas bahu temple",
      "gwalior fort",
      "teli ka mandir",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Bhopal",
    "state": "Madhya Pradesh",
    "query": "Bhopal",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "bhopal",
      "bhojpur temple",
      "bhojeshwar",
      "curzon lake",
      "shiva",
      "madhya pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Khatu (Khatu Shyam Ji)",
    "state": "Rajasthan",
    "query": "Khatu",
    "image": "/assets/temple-images/khatu-shyam-ji-rajasthan/timing.jpg",
    "keywords": [
      "khatu",
      "khatu shyam",
      "barbarik",
      "hare ka sahara",
      "sikar",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Khatu"
  },
  {
    "name": "Salasar (Salasar Balaji)",
    "state": "Rajasthan",
    "query": "Salasar",
    "image": "/assets/temple-images/salasar-balaji-rajasthan/timing.jpg",
    "keywords": [
      "salasar",
      "salasar balaji",
      "hanuman",
      "churu",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Salasar"
  },
  {
    "name": "Nathdwara (Shrinathji)",
    "state": "Rajasthan",
    "query": "Nathdwara",
    "image": "/assets/temple-images/shrinathji-temple-nathdwara/timing.jpg",
    "keywords": [
      "nathdwara",
      "shrinathji",
      "krishna",
      "haveli",
      "statue of belief",
      "rajsamand",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Nathdwara"
  },
  {
    "name": "Pushkar",
    "state": "Rajasthan",
    "query": "Pushkar",
    "image": "/assets/trending/bhadrakali-temple.webp",
    "keywords": [
      "pushkar",
      "brahma temple",
      "pushkar lake",
      "varaha temple",
      "savitri temple",
      "ajmer",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Jaipur",
    "state": "Rajasthan",
    "query": "Jaipur",
    "image": "/assets/temple-images/govind-dev-ji-temple-jaipur/timing.jpg",
    "keywords": [
      "jaipur",
      "govind dev ji",
      "moti dungri",
      "birla mandir jaipur",
      "galta ji",
      "pink city",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Jaipur"
  },
  {
    "name": "Mehandipur (Balaji)",
    "state": "Rajasthan",
    "query": "Mehandipur",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "mehandipur",
      "mehandipur balaji",
      "hanuman",
      "dausa",
      "pret raj",
      "bhairav",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ajmer",
    "state": "Rajasthan",
    "query": "Ajmer",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "ajmer",
      "dargah sharif",
      "nareli jain temple",
      "ana sagar",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Udaipur",
    "state": "Rajasthan",
    "query": "Udaipur",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "udaipur",
      "jagdish temple",
      "eklingji",
      "karni mata udaipur",
      "lake pichola",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Bikaner (Deshnok)",
    "state": "Rajasthan",
    "query": "Bikaner",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "bikaner",
      "deshnok",
      "karni mata",
      "rat temple",
      "mukto",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Mount Abu",
    "state": "Rajasthan",
    "query": "Mount Abu",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "mount abu",
      "dilwara temples",
      "jain marble",
      "arbuda devi",
      "guru shikhar",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ramdevra",
    "state": "Rajasthan",
    "query": "Ramdevra",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "ramdevra",
      "baba ramdev",
      "runicha",
      "jaisalmer",
      "pokhran",
      "rajasthan"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Puri",
    "state": "Odisha",
    "query": "Puri",
    "image": "/assets/trending/jaganath-puri.webp",
    "keywords": [
      "puri",
      "jagannath",
      "balabhadra",
      "subhadra",
      "char dham",
      "ratha yatra",
      "gundicha",
      "odisha"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Puri"
  },
  {
    "name": "Bhubaneswar",
    "state": "Odisha",
    "query": "Bhubaneswar",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "bhubaneswar",
      "lingaraj",
      "mukteshwar",
      "rajarani",
      "ekamra kshetra",
      "ananta vasudeva",
      "odisha"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Konark",
    "state": "Odisha",
    "query": "Konark",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "konark",
      "sun temple",
      "black pagoda",
      "chandrabhaga beach",
      "unesco",
      "odisha"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Taratarini",
    "state": "Odisha",
    "query": "Taratarini",
    "image": "/assets/trending/maa-taratarini.webp",
    "keywords": [
      "taratarini",
      "maa taratarini",
      "shaktipeeth",
      "rushikulya",
      "ganjam",
      "odisha"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kolkata",
    "state": "West Bengal",
    "query": "Kolkata",
    "image": "/assets/trending/kalighat-kali.webp",
    "keywords": [
      "kolkata",
      "calcutta",
      "kalighat",
      "kali",
      "dakshineswar",
      "belur math",
      "ramakrishna",
      "west bengal"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Mayapur (Nabadwip)",
    "state": "West Bengal",
    "query": "Mayapur",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "mayapur",
      "iskcon headquarters",
      "tovp",
      "chaitanya mahaprabhu",
      "nabadwip",
      "nadia",
      "west bengal"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Tarapith",
    "state": "West Bengal",
    "query": "Tarapith",
    "image": "/assets/trending/kalighat-kali.webp",
    "keywords": [
      "tarapith",
      "maa tara",
      "bamakhyapa",
      "birbhum",
      "shaktipeeth",
      "west bengal"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gangasagar",
    "state": "West Bengal",
    "query": "Gangasagar",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "gangasagar",
      "kapil muni",
      "makar sankranti",
      "sagar island",
      "bay of bengal",
      "west bengal"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gaya (Bodh Gaya)",
    "state": "Bihar",
    "query": "Gaya",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "gaya",
      "bodh gaya",
      "vishnupad",
      "falgu river",
      "pind daan",
      "mahabodhi temple",
      "buddha",
      "bihar"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Patna",
    "state": "Bihar",
    "query": "Patna",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "patna",
      "mahavir mandir",
      "takht sri patna sahib",
      "guru gobind singh",
      "patneshwari",
      "ganga",
      "bihar"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Rajgir",
    "state": "Bihar",
    "query": "Rajgir",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "rajgir",
      "vishwa shanti stupa",
      "hot springs",
      "brahmakund",
      "gridhakuta",
      "bihar"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Deoghar (Baba Baidyanath Dham)",
    "state": "Jharkhand",
    "query": "Deoghar",
    "image": "/assets/trending/baidyanath.webp",
    "keywords": [
      "deoghar",
      "baidyanath",
      "baba dham",
      "jyotirlinga",
      "shravani mela",
      "naulakha mandir",
      "jharkhand"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Deoghar"
  },
  {
    "name": "Ranchi",
    "state": "Jharkhand",
    "query": "Ranchi",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "ranchi",
      "jagannath mandir ranchi",
      "pahari mandir",
      "rajrappa",
      "chhinnamasta",
      "jharkhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Shikharji (Parasnath)",
    "state": "Jharkhand",
    "query": "Shikharji",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "shikharji",
      "sammed shikharji",
      "parasnath",
      "jain tirth",
      "tirthankara",
      "giridih",
      "jharkhand"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Guwahati",
    "state": "Assam",
    "query": "Guwahati",
    "image": "/assets/trending/kamakhya.webp",
    "keywords": [
      "guwahati",
      "kamakhya",
      "shaktipeeth",
      "nilachal hill",
      "ambubachi mela",
      "umananda",
      "brahmaputra",
      "assam"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Guwahati"
  },
  {
    "name": "Hajo",
    "state": "Assam",
    "query": "Hajo",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "hajo",
      "hayagriva madhava",
      "powa mecca",
      "kamrup",
      "assam"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Amritsar",
    "state": "Punjab",
    "query": "Amritsar",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "amritsar",
      "golden temple",
      "harmandir sahib",
      "durgiana mandir",
      "ram tirth",
      "punjab"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Anandpur Sahib",
    "state": "Punjab",
    "query": "Anandpur Sahib",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "anandpur sahib",
      "takht kesgarh sahib",
      "khalsa",
      "hola mohalla",
      "punjab"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Patiala",
    "state": "Punjab",
    "query": "Patiala",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "patiala",
      "kali devi mandir",
      "dukh niwaran sahib",
      "punjab"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kurukshetra",
    "state": "Haryana",
    "query": "Kurukshetra",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "kurukshetra",
      "brahma sarovar",
      "jyotisar",
      "bhagavad gita",
      "sthaneshwar mahadev",
      "haryana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Panchkula",
    "state": "Haryana",
    "query": "Panchkula",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "panchkula",
      "mansa devi",
      "mata mansa devi",
      "nada sahib",
      "haryana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Kangra",
    "state": "Himachal Pradesh",
    "query": "Kangra",
    "image": "/assets/temple-images/bajreshwari-devi-temple-kangra/timing.jpg",
    "keywords": [
      "kangra",
      "bajreshwari",
      "chamunda devi",
      "shaktipeeth",
      "kangra fort",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Kangra"
  },
  {
    "name": "Jwalamukhi (Jwala Ji)",
    "state": "Himachal Pradesh",
    "query": "Jwalamukhi",
    "image": "/assets/trending/jwalaji-temple.webp",
    "keywords": [
      "jwalamukhi",
      "jwala ji",
      "eternal flame",
      "shaktipeeth",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Chintpurni",
    "state": "Himachal Pradesh",
    "query": "Chintpurni",
    "image": "/assets/temple-images/chintpurni-devi-temple-himachal/timing.jpg",
    "keywords": [
      "chintpurni",
      "chhinnamastika",
      "shaktipeeth",
      "una",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Chintpurni"
  },
  {
    "name": "Naina Devi (Bilaspur)",
    "state": "Himachal Pradesh",
    "query": "Bilaspur",
    "image": "/assets/temple-images/naina-devi-temple-bilaspur/timing.jpg",
    "keywords": [
      "naina devi",
      "bilaspur himachal",
      "shaktipeeth",
      "gobind sagar",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Bilaspur"
  },
  {
    "name": "Kullu (Manali / Bijli Mahadev)",
    "state": "Himachal Pradesh",
    "query": "Kullu",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "kullu",
      "manali",
      "bijli mahadev",
      "hadimba devi",
      "vashisht",
      "manikaran",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Shimla",
    "state": "Himachal Pradesh",
    "query": "Shimla",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "shimla",
      "jakhoo temple",
      "hanuman shimla",
      "tara devi",
      "sankat mochan",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Baijnath",
    "state": "Himachal Pradesh",
    "query": "Baijnath",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "baijnath",
      "baijnath mahadev",
      "vaidyanath",
      "kangra valley",
      "ravana shiva",
      "himachal pradesh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Katra (Mata Vaishno Devi)",
    "state": "Jammu and Kashmir",
    "query": "Katra",
    "image": "/assets/trending/vaishno-devi.webp",
    "keywords": [
      "katra",
      "vaishno devi",
      "mata rani",
      "trikuta",
      "bhavan",
      "ardhkuwari",
      "bhairon nath",
      "jammu and kashmir"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Katra"
  },
  {
    "name": "Srinagar",
    "state": "Jammu and Kashmir",
    "query": "Srinagar",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "srinagar",
      "shankaracharya temple",
      "kheer bhawani",
      "dal lake",
      "hari parbat",
      "jammu and kashmir"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Jammu",
    "state": "Jammu and Kashmir",
    "query": "Jammu",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "jammu",
      "raghunath temple",
      "bawe wali mata",
      "bahu fort",
      "kol kandoli",
      "city of temples",
      "jammu and kashmir"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Jammu"
  },
  {
    "name": "Anantnag (Amarnath Base)",
    "state": "Jammu and Kashmir",
    "query": "Amarnath",
    "image": "/assets/tample/amarnath-temple.svg",
    "keywords": [
      "anantnag",
      "amarnath",
      "baba barfani",
      "pahalgham",
      "baltal",
      "martand sun temple",
      "jammu and kashmir"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Amarnath"
  },
  {
    "name": "Leh (Ladakh)",
    "state": "Ladakh",
    "query": "Leh",
    "image": "/assets/banner/vr-darshan/temples/kedarnath.webp",
    "keywords": [
      "leh",
      "ladakh",
      "spituk gompa",
      "thiksey monastery",
      "hemis",
      "shanti stupa",
      "ladakh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Hyderabad",
    "state": "Telangana",
    "query": "Hyderabad",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "hyderabad",
      "birla mandir hyderabad",
      "chilkur balaji",
      "visa balaji",
      "bhagyalakshmi",
      "sanghi temple",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Yadagirigutta",
    "state": "Telangana",
    "query": "Yadagirigutta",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "yadagirigutta",
      "yadadri",
      "lakshmi narasimha",
      "bhuvanagiri",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Warangal",
    "state": "Telangana",
    "query": "Warangal",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "warangal",
      "thousand pillar temple",
      "bhadrakali temple",
      "ramappa temple",
      "kakatiya",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Bhadrachalam",
    "state": "Telangana",
    "query": "Bhadrachalam",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "bhadrachalam",
      "sita ramachandra swamy",
      "godavari",
      "ramadasu",
      "bhadradri",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Vemulawada",
    "state": "Telangana",
    "query": "Vemulawada",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "vemulawada",
      "raja rajeswara",
      "dakshina kashi",
      "rajanna",
      "siricilla",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Basar",
    "state": "Telangana",
    "query": "Basar",
    "image": "/assets/home/what-to-do/temple-8.webp",
    "keywords": [
      "basar",
      "gnana saraswati",
      "aksharabhyasam",
      "godavari",
      "nirmal",
      "telangana"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Raipur",
    "state": "Chhattisgarh",
    "query": "Raipur",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "raipur",
      "dudhadhari math",
      "mahamaya temple raipur",
      "shadani darbar",
      "chhattisgarh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Dantewada",
    "state": "Chhattisgarh",
    "query": "Dantewada",
    "image": "/assets/home/what-to-do/temple-3.webp",
    "keywords": [
      "dantewada",
      "danteshwari mai",
      "shaktipeeth",
      "bastar",
      "shankhini dankini",
      "chhattisgarh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Dongargarh",
    "state": "Chhattisgarh",
    "query": "Dongargarh",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "dongargarh",
      "maa bambleshwari",
      "bambleshwari hill",
      "rajnandgaon",
      "chhattisgarh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Panaji",
    "state": "Goa",
    "query": "Panaji",
    "image": "/assets/home/what-to-do/temple-7.webp",
    "keywords": [
      "panaji",
      "panjim",
      "mahalaxmi goa",
      "maruti temple",
      "mandovi",
      "goa"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Ponda",
    "state": "Goa",
    "query": "Ponda",
    "image": "/assets/home/what-to-do/temple-5.webp",
    "keywords": [
      "ponda",
      "mangueshi temple",
      "shanta durga",
      "nagueshi",
      "ramnathi",
      "goa"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "New Delhi",
    "state": "Delhi",
    "query": "Delhi",
    "image": "/assets/temple-images/akshardham-temple-delhi/timing.jpg",
    "keywords": [
      "delhi",
      "new delhi",
      "akshardham delhi",
      "kalkaji mandir",
      "birla mandir delhi",
      "jhandewalan",
      "gurudwara bangla sahib",
      "lotus temple",
      "delhi"
    ],
    "type": "city",
    "hasTemples": true,
    "route": "/listing?search=Delhi"
  },
  {
    "name": "Chandigarh",
    "state": "Chandigarh",
    "query": "Chandigarh",
    "image": "/assets/home/what-to-do/temple-2.webp",
    "keywords": [
      "chandigarh",
      "chandi mandir",
      "mansa devi",
      "rock garden",
      "chandigarh"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Puducherry (Pondicherry)",
    "state": "Puducherry",
    "query": "Puducherry",
    "image": "/assets/trending/rameshwaram.webp",
    "keywords": [
      "puducherry",
      "pondicherry",
      "manakula vinayagar",
      "sri aurobindo ashram",
      "auroville",
      "puducherry"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Gangtok (Sikkim)",
    "state": "Sikkim",
    "query": "Gangtok",
    "image": "/assets/home/what-to-do/temple-6.webp",
    "keywords": [
      "gangtok",
      "sikkim",
      "enchey monastery",
      "ganesh tok",
      "hanuman tok",
      "rumtek",
      "sikkim"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Namchi (Char Dham Sikkim)",
    "state": "Sikkim",
    "query": "Namchi",
    "image": "/assets/home/what-to-do/temple-1.webp",
    "keywords": [
      "namchi",
      "siddheshwar dham",
      "char dham sikkim",
      "shiva statue",
      "guru padmasambhava",
      "sikkim"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Udaipur (Tripura Sundari)",
    "state": "Tripura",
    "query": "Tripura Sundari",
    "image": "/assets/trending/kamakhya.webp",
    "keywords": [
      "tripura",
      "agartala",
      "tripura sundari",
      "matabari",
      "shaktipeeth",
      "kurma peeth",
      "tripura"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Parshuram Kund (Arunachal)",
    "state": "Arunachal Pradesh",
    "query": "Parshuram Kund",
    "image": "/assets/home/what-to-do/temple-4.webp",
    "keywords": [
      "arunachal pradesh",
      "parshuram kund",
      "lohit river",
      "makar sankranti",
      "tawang",
      "arunachal"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  },
  {
    "name": "Port Blair",
    "state": "Andaman and Nicobar Islands",
    "query": "Port Blair",
    "image": "/assets/trending/rameshwaram.webp",
    "keywords": [
      "port blair",
      "andaman",
      "sri vetrimalai murugan",
      "cellular jail",
      "andaman and nicobar"
    ],
    "type": "city",
    "hasTemples": false,
    "route": "/coming-soon"
  }
];

export const getCityImage = (cityName, query) => {
  const q = (query || cityName || "").toLowerCase().trim();
  const found = allCitiesData.find((c) => {
    const cName = c.name.toLowerCase();
    const cQuery = (c.query || "").toLowerCase();
    return q.includes(cQuery) || cQuery.includes(q) || q.includes(cName) || cName.includes(q);
  });
  if (found && found.image) return found.image;
  return "/assets/home/what-to-do/temple-1.webp";
};

// =====================================================
// STATE TO TEMPLES DATA MAPPING (All 51 Temples Across 16 States)
// =====================================================

export const stateToTemplesData = {
  "Uttar Pradesh": [
    {
      name: "Ayodhya Ram Mandir (Shri Ram Janmabhoomi)",
      route: "/ayodhya",
      slug: "ayodhya",
      image: "/assets/trending/ayodhya-mandir.webp",
      deity: "Lord Ram (Ram Lalla)",
      location: "Ayodhya, Uttar Pradesh",
      city: "Ayodhya",
      state: "Uttar Pradesh"
    },
    {
      name: "Kashi Vishwanath Temple",
      route: "/kashi-vishwanath",
      slug: "kashi-vishwanath",
      image: "/assets/trending/kashi-vishwanath.webp",
      deity: "Lord Shiva (Vishwanath Jyotirlinga)",
      location: "Varanasi, Uttar Pradesh",
      city: "Varanasi",
      state: "Uttar Pradesh"
    },
    {
      name: "Shri Banke Bihari Mandir",
      route: "/temple/shri-banke-bihari-mandir",
      slug: "shri-banke-bihari-mandir",
      image: "https://vrindavandarshan.in/wp-content/uploads/2024/10/banke-bihari-temple-vrindavan-8.jpg",
      deity: "Lord Krishna (Thakur Ji)",
      location: "Vrindavan, Mathura, Uttar Pradesh",
      city: "Vrindavan",
      state: "Uttar Pradesh"
    },
    {
      name: "Prem Mandir",
      route: "/temple/prem-mandir",
      slug: "prem-mandir",
      image: "https://wanderon-images.gumlet.io/gallery/new/2025/08/08/1754651207820-prem-mandir-the-temple-of-love-in-vrindavan.jpg?auto=compress%2Cformat&w=1280",
      deity: "Radha Krishna & Sita Ram",
      location: "Vrindavan, Mathura, Uttar Pradesh",
      city: "Vrindavan",
      state: "Uttar Pradesh"
    },
    {
      name: "Shri Krishna Janmabhoomi Temple Complex",
      route: "/temple/shri-krishna-janmabhoomi-temple-complex",
      slug: "shri-krishna-janmabhoomi-temple-complex",
      image: "https://vrindavandarshan.in/wp-content/uploads/2023/12/jamanbhumi-mathura.jpg",
      deity: "Lord Krishna",
      location: "Mathura, Uttar Pradesh",
      city: "Mathura",
      state: "Uttar Pradesh"
    },
    {
      name: "Hanuman Garhi, Ayodhya",
      route: "/temple/hanuman-garhi-ayodhya",
      slug: "hanuman-garhi-ayodhya",
      image: "https://images.beyondyatra.com/dest/ayodhya/places/hanuman-garhi-uttar-pradesh-india_img_2.jpg",
      deity: "Lord Hanuman",
      location: "Ayodhya, Uttar Pradesh",
      city: "Ayodhya",
      state: "Uttar Pradesh"
    },
    {
      name: "Maa Vindhyavasini Temple",
      route: "/temple/maa-vindhyavasini-temple",
      slug: "maa-vindhyavasini-temple",
      image: "https://thetempleguru.com/wp-content/uploads/2023/04/Vindhyavasini-temple-vindhyachal-3-1.jpg",
      deity: "Maa Vindhyavasini (Durga)",
      location: "Vindhyachal, Mirzapur, Uttar Pradesh",
      city: "Mirzapur",
      state: "Uttar Pradesh"
    },
    {
      name: "Sri Sri Krishna Balaram Mandir (ISKCON)",
      route: "/temple/sri-sri-krishna-balaram-mandir-iskcon-vrindavan",
      slug: "sri-sri-krishna-balaram-mandir-iskcon-vrindavan",
      image: "https://images.brajrasik.org/5e70a6fa2f04a800619e3fd3.jpeg",
      deity: "Lord Krishna & Balaram",
      location: "Vrindavan, Mathura, Uttar Pradesh",
      city: "Vrindavan",
      state: "Uttar Pradesh"
    }
  ],

  "Uttarakhand": [
    {
      name: "Shri Kedarnath Temple",
      route: "/kedarnath",
      slug: "kedarnath-temple",
      image: "/assets/banner/vr-darshan/temples/kedarnath.webp",
      deity: "Lord Shiva (Kedarnath Jyotirlinga)",
      location: "Kedarnath, Rudraprayag, Uttarakhand",
      city: "Kedarnath",
      state: "Uttarakhand"
    },
    {
      name: "Shri Badrinath Temple",
      route: "/temple/shri-badrinath-temple",
      slug: "shri-badrinath-temple",
      image: "https://api.theindia.co.in/storage/image/places/image/shree-badrinath-dham-374345.jpg",
      deity: "Lord Vishnu (Badri Vishal)",
      location: "Badrinath, Chamoli, Uttarakhand",
      city: "Badrinath",
      state: "Uttarakhand"
    },
    {
      name: "Maa Mansa Devi Temple, Haridwar",
      route: "/temple/maa-mansa-devi-temple-haridwar",
      slug: "maa-mansa-devi-temple-haridwar",
      image: "https://www.indiaeasytrip.com/images/mansa-devi-temple-haridwar.jpg",
      deity: "Goddess Mansa Devi",
      location: "Haridwar, Uttarakhand",
      city: "Haridwar",
      state: "Uttarakhand"
    },
    {
      name: "Har Ki Pauri / Ganga Aarti",
      route: "/temple/har-ki-pauri-ganga-aarti",
      slug: "har-ki-pauri-ganga-aarti",
      image: "https://imgcld.yatra.com/ytimages/image/upload/t_yt_blog_w_800_c_fill_g_auto_q_auto%3Agood_f_jpg/v1528691448/Haridwar098_1528690394.jpg",
      deity: "Maa Ganga",
      location: "Haridwar, Uttarakhand",
      city: "Haridwar",
      state: "Uttarakhand"
    }
  ],

  "Gujarat": [
    {
      name: "Dwarkadhish Temple",
      route: "/dwarkadhish-temple",
      slug: "dwarkadhish-temple",
      image: "/assets/trending/dwarkadhish.webp",
      deity: "Lord Krishna (Dwarkadhish)",
      location: "Dwarka, Gujarat",
      city: "Dwarka",
      state: "Gujarat"
    },
    {
      name: "Shree Somnath Temple",
      route: "/temple/shree-somnath-temple",
      slug: "shree-somnath-temple",
      image: "https://2.bp.blogspot.com/-gVglkLRORDA/Uh2oZK6zzdI/AAAAAAAAAbM/5P3ppdI_Qxo/s1600/Somnath_mandir.jpg",
      deity: "Lord Shiva (First Jyotirlinga)",
      location: "Prabhas Patan, Gir Somnath, Gujarat",
      city: "Somnath",
      state: "Gujarat"
    },
    {
      name: "Shri Arasuri Ambaji Mata Temple",
      route: "/temple/shri-arasuri-ambaji-mata-temple",
      slug: "shri-arasuri-ambaji-mata-temple",
      image: "https://images.indianexpress.com/2023/03/ambaji-temple.jpg?w=1200",
      deity: "Maa Amba (Shakti Peeth)",
      location: "Ambaji, Banaskantha, Gujarat",
      city: "Ambaji",
      state: "Gujarat"
    },
    {
      name: "Shree Kalika Mataji Temple, Pavagadh",
      route: "/temple/shree-kalika-mataji-temple-pavagadh",
      slug: "shree-kalika-mataji-temple-pavagadh",
      image: "https://images.beyondyatra.com/dest/pavagadh-hill/places/kalika-mata-temple-pavagadh-gujarat-india-gujarat-india_img_3.jpg",
      deity: "Maa Kalika",
      location: "Pavagadh Hill, Panchmahal, Gujarat",
      city: "Pavagadh",
      state: "Gujarat"
    }
  ],

  "Himachal Pradesh": [
    {
      name: "Maa Chintpurni Temple",
      route: "/temple/maa-chintpurni-temple",
      slug: "maa-chintpurni-temple",
      image: "https://d3fphkxyf5o5bm.cloudfront.net/image-resize/format%3Dwebp%2Cw%3D720/QwRY54Li1HMwD7oNfouIzfQQCm1zLceTjBkd5PB9Hu",
      deity: "Maa Chintpurni (Chhinnamastika)",
      location: "Chintpurni, Una, Himachal Pradesh",
      city: "Chintpurni",
      state: "Himachal Pradesh"
    },
    {
      name: "Jwala Ji Temple",
      route: "/temple/jwala-ji-temple",
      slug: "jwala-ji-temple",
      image: "https://realhimachal.in/wp-content/uploads/2023/12/Jawamukhi-Temple-Jawala-Ji.jpg",
      deity: "Goddess Jwala Ji (Eternal Flame)",
      location: "Jawalamukhi, Kangra, Himachal Pradesh",
      city: "Kangra",
      state: "Himachal Pradesh"
    },
    {
      name: "Shri Naina Devi Temple",
      route: "/temple/shri-naina-devi-temple",
      slug: "shri-naina-devi-temple",
      image: "https://static.punjabkesari.in/multimedia/2026_3image_16_53_458710918nainadevi.jpg",
      deity: "Maa Naina Devi",
      location: "Naina Devi, Bilaspur, Himachal Pradesh",
      city: "Bilaspur",
      state: "Himachal Pradesh"
    },
    {
      name: "Shri Bajreshwari Devi Temple",
      route: "/temple/shri-bajreshwari-devi-temple",
      slug: "shri-bajreshwari-devi-temple",
      image: "https://tourism-kangra.weebly.com/uploads/3/0/2/3/30239281/7418219_orig.jpg",
      deity: "Maa Bajreshwari (Kangra Devi)",
      location: "Kangra, Himachal Pradesh",
      city: "Kangra",
      state: "Himachal Pradesh"
    },
    {
      name: "Chamunda Devi Temple, Kangra",
      route: "/temple/chamunda-devi-temple-kangra",
      slug: "chamunda-devi-temple-kangra",
      image: "https://www.beingpahadia.com/wp-content/uploads/2020/02/chamundaji-min.jpg",
      deity: "Maa Chamunda Devi",
      location: "Chamunda, Kangra, Himachal Pradesh",
      city: "Kangra",
      state: "Himachal Pradesh"
    }
  ],

  "Maharashtra": [
    {
      name: "Shri Saibaba Samadhi Mandir",
      route: "/temple/shri-saibaba-samadhi-mandir",
      slug: "shri-saibaba-samadhi-mandir",
      image: "https://hotelsaichhatra.com/images/uploads/427/3786Samadhi_Mandir.png",
      deity: "Shri Sai Baba",
      location: "Shirdi, Ahmednagar, Maharashtra",
      city: "Shirdi",
      state: "Maharashtra"
    },
    {
      name: "Shree Siddhivinayak Ganapati Mandir",
      route: "/temple/shree-siddhivinayak-ganapati-mandir",
      slug: "shree-siddhivinayak-ganapati-mandir",
      image: "https://static.sanatanprabhat.org/wp-content/uploads/sites/3/2023/12/09225919/800px-Shree_Siddhivinayak_Temple_Mumbai-1.jpg",
      deity: "Lord Ganesha",
      location: "Prabhadevi, Mumbai, Maharashtra",
      city: "Mumbai",
      state: "Maharashtra"
    },
    {
      name: "Shrimant Dagdusheth Halwai Ganpati",
      route: "/temple/shrimant-dagdusheth-halwai-ganpati",
      slug: "shrimant-dagdusheth-halwai-ganpati",
      image: "https://utsav.gov.in/public/uploads/darshan_cover_image/darshan_42/1651224930143200465.jpg",
      deity: "Lord Ganesha",
      location: "Pune, Maharashtra",
      city: "Pune",
      state: "Maharashtra"
    },
    {
      name: "Trimbakeshwar Jyotirlinga Temple",
      route: "/temple/trimbakeshwar-jyotirlinga-temple",
      slug: "trimbakeshwar-jyotirlinga-temple",
      image: "/assets/trending/trimbakeshwar.webp",
      deity: "Lord Shiva (Trimbakeshwar Jyotirlinga)",
      location: "Trimbak, Nashik, Maharashtra",
      city: "Nashik",
      state: "Maharashtra"
    }
  ],

  "Rajasthan": [
    {
      name: "Shri Khatu Shyam Ji Temple",
      route: "/temple/shri-khatu-shyam-ji-temple",
      slug: "shri-khatu-shyam-ji-temple",
      image: "https://www.taleof2backpackers.com/wp-content/uploads/2020/01/Khatu-Shyamji-Temple-Rajasthan-Peepal-tree.jpg",
      deity: "Barbarika (Khatu Shyam Ji)",
      location: "Khatu, Sikar, Rajasthan",
      city: "Khatu",
      state: "Rajasthan"
    },
    {
      name: "Shrinathji Temple",
      route: "/temple/shrinathji-temple",
      slug: "shrinathji-temple",
      image: "https://www.postoast.com/wp-content/uploads/2018/02/Shrinathji-Temple-Nathdwara-Places-Near-Udaipur.jpg",
      deity: "Lord Krishna (Shrinathji)",
      location: "Nathdwara, Rajsamand, Rajasthan",
      city: "Nathdwara",
      state: "Rajasthan"
    },
    {
      name: "Salasar Balaji Temple",
      route: "/temple/salasar-balaji-temple",
      slug: "salasar-balaji-temple",
      image: "https://static.zoomnews.com/photo/msid-109531649%2Cwidth-1280%2Cheight-720/109531649.jpg",
      deity: "Lord Hanuman (Salasar Balaji)",
      location: "Salasar, Churu, Rajasthan",
      city: "Salasar",
      state: "Rajasthan"
    },
    {
      name: "Govind Dev Ji Temple",
      route: "/temple/govind-dev-ji-temple",
      slug: "govind-dev-ji-temple",
      image: "https://upload.wikimedia.org/wikipedia/commons/5/54/Govind_Dev_Ji_Temple%2C_Jaipur%2C_20191218_1059_9091.jpg",
      deity: "Lord Krishna (Govind Dev Ji)",
      location: "Jaipur, Rajasthan",
      city: "Jaipur",
      state: "Rajasthan"
    }
  ],

  "Tamil Nadu": [
    {
      name: "Ramanathaswamy Temple",
      route: "/ramanathaswamy-temple",
      slug: "ramanathaswamy-temple",
      image: "/assets/trending/rameshwaram.webp",
      deity: "Lord Shiva (Ramanathaswamy Jyotirlinga)",
      location: "Rameswaram, Tamil Nadu",
      city: "Rameswaram",
      state: "Tamil Nadu"
    },
    {
      name: "Meenakshi Amman Temple",
      route: "/temple/meenakshi-amman-temple",
      slug: "meenakshi-amman-temple",
      image: "https://images.trvl-media.com/place/6104746/9408fbf0-e48c-49bf-afb7-f48b2e66075a.jpg",
      deity: "Goddess Meenakshi & Sundareswarar",
      location: "Madurai, Tamil Nadu",
      city: "Madurai",
      state: "Tamil Nadu"
    },
    {
      name: "Arunachaleswarar Temple",
      route: "/temple/arunachaleswarar-temple",
      slug: "arunachaleswarar-temple",
      image: "https://i.pinimg.com/736x/2d/ba/c9/2dbac9c2437e93df02720450dae93863.jpg",
      deity: "Lord Shiva (Agni Lingam)",
      location: "Tiruvannamalai, Tamil Nadu",
      city: "Tiruvannamalai",
      state: "Tamil Nadu"
    },
    {
      name: "Palani Dhandayuthapani Swamy Temple",
      route: "/temple/palani-dhandayuthapani-swamy-temple",
      slug: "palani-dhandayuthapani-swamy-temple",
      image: "https://upload.wikimedia.org/wikipedia/commons/4/43/Palani_Temple-WUS05301.jpg",
      deity: "Lord Murugan (Dhandayuthapani)",
      location: "Palani, Dindigul, Tamil Nadu",
      city: "Palani",
      state: "Tamil Nadu"
    }
  ],

  "Karnataka": [
    {
      name: "Kollur Mookambika Temple",
      route: "/temple/kollur-mookambika-temple",
      slug: "kollur-mookambika-temple",
      image: "https://hel1.your-objectstorage.com/goodpass/placexplore-5c53f59c/products/65320ac8587afcb3c4ab367d/images/a03d9475-c4d0-4547-8de4-58ea9f4b0d5d.jpg",
      deity: "Goddess Mookambika",
      location: "Kollur, Udupi, Karnataka",
      city: "Kollur",
      state: "Karnataka"
    },
    {
      name: "Udupi Sri Krishna Matha",
      route: "/temple/udupi-sri-krishna-matha",
      slug: "udupi-sri-krishna-matha",
      image: "https://cdn.travelpal.ai/prod/places/WgUTqCY-TKVCu6oyefMZMNVw8lA/photos/google/webp/c355e3fc10c4f5b670c08353.webp",
      deity: "Lord Krishna (Bala Krishna)",
      location: "Udupi, Karnataka",
      city: "Udupi",
      state: "Karnataka"
    },
    {
      name: "Kukke Shri Subrahmanya Temple",
      route: "/temple/kukke-shri-subrahmanya-temple",
      slug: "kukke-shri-subrahmanya-temple",
      image: "https://2.bp.blogspot.com/-wGdYxluUmGA/VFZeIGlidSI/AAAAAAAACI8/wLesQ8w7l1I/s1600/1.jpg",
      deity: "Lord Subrahmanya (Kartikeya)",
      location: "Kukke Subrahmanya, Dakshina Kannada, Karnataka",
      city: "Kukke Subrahmanya",
      state: "Karnataka"
    },
    {
      name: "Shri Manjunatha Temple, Dharmasthala",
      route: "/temple/shri-manjunatha-temple-dharmasthala",
      slug: "shri-manjunatha-temple-dharmasthala",
      image: "https://viharadarshani.in/wp-content/uploads/2025/01/Dharmasthala-manjunatha-swamy-Temple.jpg",
      deity: "Lord Shiva (Manjunatha)",
      location: "Dharmasthala, Dakshina Kannada, Karnataka",
      city: "Dharmasthala",
      state: "Karnataka"
    }
  ],

  "Kerala": [
    {
      name: "Sabarimala Sree Dharma Sastha Temple",
      route: "/temple/sabarimala-sree-dharma-sastha-temple",
      slug: "sabarimala-sree-dharma-sastha-temple",
      image: "https://2.bp.blogspot.com/-qCqTIFFx3Eo/VYrj_xgJY0I/AAAAAAAABn0/H86teW3BVNo/w1200-h630-p-k-no-nu/sabarimala_deity.jpg",
      deity: "Lord Ayyappa (Dharma Sastha)",
      location: "Sannidhanam, Pathanamthitta, Kerala",
      city: "Sabarimala",
      state: "Kerala"
    },
    {
      name: "Guruvayur Sri Krishna Temple",
      route: "/temple/guruvayur-sri-krishna-temple",
      slug: "guruvayur-sri-krishna-temple",
      image: "https://img.traveltriangle.com/blog/wp-content/uploads/2024/06/hotels-near-Guruvayur-temple.jpg",
      deity: "Lord Krishna (Guruvayurappan)",
      location: "Guruvayur, Thrissur, Kerala",
      city: "Guruvayur",
      state: "Kerala"
    },
    {
      name: "Sree Padmanabhaswamy Temple",
      route: "/temple/sree-padmanabhaswamy-temple",
      slug: "sree-padmanabhaswamy-temple",
      image: "https://www.southindianroutes.com/storage/11309/trivandrum-featured-image1.webp",
      deity: "Lord Vishnu (Anantha Padmanabha)",
      location: "Thiruvananthapuram, Kerala",
      city: "Thiruvananthapuram",
      state: "Kerala"
    }
  ],

  "Andhra Pradesh": [
    {
      name: "Sri Venkateswara Swamy Temple",
      route: "/temple/sri-venkateswara-swamy-temple",
      slug: "sri-venkateswara-swamy-temple",
      image: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Tirumala_Venkateswara_temple_entrance_09062015.JPG",
      deity: "Lord Venkateswara (Balaji)",
      location: "Tirumala, Tirupati, Andhra Pradesh",
      city: "Tirupati",
      state: "Andhra Pradesh"
    },
    {
      name: "Sri Mallikarjuna Swamy Temple, Srisailam",
      route: "/temple/sri-mallikarjuna-swamy-temple-srisailam",
      slug: "sri-mallikarjuna-swamy-temple-srisailam",
      image: "/assets/trending/mallikarjuna.webp",
      deity: "Lord Shiva & Bhramaramba Devi",
      location: "Srisailam, Andhra Pradesh",
      city: "Srisailam",
      state: "Andhra Pradesh"
    },
    {
      name: "Kanaka Durga Temple",
      route: "/temple/kanaka-durga-temple",
      slug: "kanaka-durga-temple",
      image: "https://yatradham.org/media/catalog/product/i/m/img_9988.jpg",
      deity: "Goddess Kanaka Durga",
      location: "Vijayawada, Andhra Pradesh",
      city: "Vijayawada",
      state: "Andhra Pradesh"
    }
  ],

  "Madhya Pradesh": [
    {
      name: "Shri Mahakaleshwar Jyotirlinga",
      route: "/temple/shri-mahakaleshwar-jyotirlinga",
      slug: "shri-mahakaleshwar-jyotirlinga",
      image: "/assets/trending/mahakaleshwar.webp",
      deity: "Lord Shiva (Mahakaleshwar Jyotirlinga)",
      location: "Ujjain, Madhya Pradesh",
      city: "Ujjain",
      state: "Madhya Pradesh"
    },
    {
      name: "Shri Omkareshwar Jyotirlinga",
      route: "/temple/shri-omkareshwar-jyotirlinga",
      slug: "shri-omkareshwar-jyotirlinga",
      image: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Omkareshwar_Jyotirlinga_Temple_in_Madhya_Pradesh.jpg",
      deity: "Lord Shiva (Omkareshwar Jyotirlinga)",
      location: "Omkareshwar, Khandwa, Madhya Pradesh",
      city: "Omkareshwar",
      state: "Madhya Pradesh"
    }
  ],

  "Jammu & Kashmir": [
    {
      name: "Mata Vaishno Devi Temple",
      route: "/vaishno-devi",
      slug: "vaishno-devi",
      image: "/assets/trending/vaishno-devi.webp",
      deity: "Mata Vaishno Devi",
      location: "Katra, Jammu & Kashmir",
      city: "Katra",
      state: "Jammu & Kashmir"
    },
    {
      name: "Amarnath Cave Temple",
      route: "/amarnath",
      slug: "amarnath",
      image: "/assets/tample/amarnath-temple.svg",
      deity: "Lord Shiva (Baba Barfani)",
      location: "Anantnag, Jammu & Kashmir",
      city: "Anantnag",
      state: "Jammu & Kashmir"
    }
  ],

  "Odisha": [
    {
      name: "Shree Jagannath Temple",
      route: "/temple/shree-jagannath-temple",
      slug: "shree-jagannath-temple",
      image: "/assets/trending/jaganath-puri.webp",
      deity: "Lord Jagannath, Balabhadra & Subhadra",
      location: "Puri, Odisha",
      city: "Puri",
      state: "Odisha"
    }
  ],

  "Jharkhand": [
    {
      name: "Baba Baidyanath Dham Temple",
      route: "/temple/baba-baidyanath-dham-temple",
      slug: "baba-baidyanath-dham-temple",
      image: "/assets/trending/baidyanath.webp",
      deity: "Lord Shiva (Baidyanath Jyotirlinga)",
      location: "Deoghar, Jharkhand",
      city: "Deoghar",
      state: "Jharkhand"
    }
  ],

  "Assam": [
    {
      name: "Maa Kamakhya Temple",
      route: "/temple/maa-kamakhya-temple",
      slug: "maa-kamakhya-temple",
      image: "/assets/trending/kamakhya.webp",
      deity: "Maa Kamakhya (Shakti Peeth)",
      location: "Guwahati, Assam",
      city: "Guwahati",
      state: "Assam"
    }
  ],

  "Delhi": [
    {
      name: "Swaminarayan Akshardham, Delhi",
      route: "/temple/swaminarayan-akshardham-delhi",
      slug: "swaminarayan-akshardham-delhi",
      image: "https://www.baps.org/Data/Sites/1/Media/GalleryImages/31106/WebImages/7.1.jpg",
      deity: "Bhagwan Swaminarayan",
      location: "New Delhi, Delhi",
      city: "New Delhi",
      state: "Delhi"
    }
  ]
};

// Alias for Jammu and Kashmir naming variations
stateToTemplesData["Jammu and Kashmir"] = stateToTemplesData["Jammu & Kashmir"];

// Helper function to get temples for any given state
export const getStateTemples = (stateName) => {
  if (!stateName) return [];
  const normalized = stateName.toLowerCase().trim();
  const key = Object.keys(stateToTemplesData).find(
    (k) => k.toLowerCase() === normalized || 
           (normalized.includes("jammu") && k.toLowerCase().includes("jammu"))
  );
  return key ? stateToTemplesData[key] : [];
};

// List of all active states sorted with their temple counts
export const allActiveStatesWithCounts = [
  { name: "Uttar Pradesh", count: 8 },
  { name: "Himachal Pradesh", count: 5 },
  { name: "Uttarakhand", count: 4 },
  { name: "Gujarat", count: 4 },
  { name: "Maharashtra", count: 4 },
  { name: "Rajasthan", count: 4 },
  { name: "Tamil Nadu", count: 4 },
  { name: "Karnataka", count: 4 },
  { name: "Kerala", count: 3 },
  { name: "Andhra Pradesh", count: 3 },
  { name: "Madhya Pradesh", count: 2 },
  { name: "Jammu & Kashmir", count: 2 },
  { name: "Odisha", count: 1 },
  { name: "Jharkhand", count: 1 },
  { name: "Assam", count: 1 },
  { name: "Delhi", count: 1 }
];

// All 51 mapped temples in a flat array
export const allMappedTemplesList = Object.keys(stateToTemplesData)
  .filter((st) => st !== "Jammu and Kashmir")
  .flatMap((st) => stateToTemplesData[st]);

